// extracted by mini-css-extract-plugin
export var container = "_7a-0";
export var error = "_7a-9";
export var label = "_7a-5";
export var light = "_7a-6";
export var md = "_7a-3";
export var sm = "_7a-2";
export var thin = "_7a-8";
export var thinBold = "_7a-7";
export var vertical = "_7a-4";
export var xs = "_7a-1";